import { useState, useEffect, useCallback, useRef } from 'react';
import { api, LitLegionUserLevel } from '@/lib/api';

interface UseAdminLevelsReturn {
  levels: LitLegionUserLevel[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminLevels(): UseAdminLevelsReturn {
  const [levels, setLevels] = useState<LitLegionUserLevel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const refreshRef = useRef(0);

  const fetchLevels = useCallback(async () => {
    const id = ++refreshRef.current;
    try {
      setLoading(true);
      setError(null);
      const result = await api.adminListLitLegionLevels();
      if (refreshRef.current === id) {
        setLevels(result.levels);
      }
    } catch (err) {
      if (refreshRef.current === id) {
        setError(err instanceof Error ? err.message : 'Failed to load levels');
      }
    } finally {
      if (refreshRef.current === id) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchLevels();
    return () => {
      refreshRef.current++;
    };
  }, [fetchLevels]);

  return {
    levels,
    loading,
    error,
    refresh: fetchLevels,
  };
}
